import { useEffect } from 'react';
import { API_ROUTES } from '@matchroom/shared';
import { api } from '@/lib/api-client';

/** Fetch a safe GET endpoint so the backend sets the CSRF cookie before mutating requests. */
export function useCsrfBootstrap(): void {
  useEffect(() => {
    void api.get(API_ROUTES.HEALTH).catch(() => {
      // Non-blocking — CSRF will be set on next successful GET
    });
  }, []);
}
